// Slot026 遊戲專屬訊息型別查表 helper。
// package 名 `Slot026RedRidingHood`（無底線）還原自 Unity 產生碼 SlotDef.cs 內嵌的 descriptor，
// 見 proto/SlotDef.proto 與 docs/PROTOBUF_SCHEMA.md。
import type * as protobuf from 'protobufjs'
import { lookupType } from './protoRoot'

/** 遊戲專屬 proto 套件名。含底線的 `Protobuf.Slot026_RedRidingHood` 是 csharp_namespace，非 proto package。 */
export const SLOT_PACKAGE = 'Slot026RedRidingHood'

/** 遊戲層 SpinCmd（請求 payload，包進 ClientSpinCmd.SpinData 的 Any）。 */
export function spinCmdType(): protobuf.Type {
  return lookupType(`${SLOT_PACKAGE}.SpinCmd`)
}

/** 遊戲層 SlotResult（回應，從 ResponseInfo.Data 的 Any 拆出後解析）。 */
export function slotResultType(): protobuf.Type {
  return lookupType(`${SLOT_PACKAGE}.SlotResult`)
}

/** google.protobuf.Any（兩層封裝的外層；type_url + value bytes）。 */
export function anyType(): protobuf.Type {
  return lookupType('google.protobuf.Any')
}

/** SpinData Any 的 type_url（後端以此辨識內層訊息型別）。 */
export const SPIN_DATA_TYPE_URL = `type.googleapis.com/${SLOT_PACKAGE}.SpinCmd`
